import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { captureUtm } from "@/lib/the190";
import { initAnalytics, trackPageView, initScrollDepth } from "@/lib/analytics";

import Nav190 from "@/components/the190/Nav190";
import Hero190 from "@/components/the190/Hero190";
import { Editions190 } from "@/components/the190/Editions190";
import Recognition190 from "@/components/the190/Recognition190";
import { ChapterArchive190 } from "@/components/the190/Community190";
import Faq190, {
  Purpose190,
  FinalAcquisition190,
  FinalCta190,
} from "@/components/the190/Closing190";

const SHARE_TITLE = "Nick Fraser Collector Editions | Signed Limited Edition Art";
const SHARE_DESC =
  "Discover signed and numbered Collector Editions from the Nick Fraser Archive, including Tribal Goddess and Universal Soul of Stars. Limited editions of 100 with Certificates of Authenticity.";

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

export default function The190() {
  const [data, setData] = useState(null);

  useEffect(() => {
    captureUtm();
    initAnalytics();
    trackPageView("/collector-editions");
    const cleanup = initScrollDepth();

    document.title = SHARE_TITLE;
    setMeta("name", "description", SHARE_DESC);
    setMeta("property", "og:title", SHARE_TITLE);
    setMeta("property", "og:description", SHARE_DESC);
    setMeta("property", "og:image", `${window.location.origin}/og/the190-share.jpg`);
    setMeta("property", "og:url", `${window.location.origin}/collector-editions`);
    setMeta("name", "twitter:title", SHARE_TITLE);
    setMeta("name", "twitter:description", SHARE_DESC);
    setMeta("name", "twitter:image", `${window.location.origin}/og/the190-share.jpg`);

    return cleanup;
  }, []);

  useEffect(() => {
    http
      .get("/the190")
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, []);

  return (
    <div data-testid="the190-page" className="bg-[color:var(--bone)]">
      <Nav190 />
      <main>
        <Hero190 />
        <Editions190 data={data} />
        <ChapterArchive190 />
        <Recognition190 data={data} />
        <Purpose190 />
        <Faq190 data={data} />
        <FinalAcquisition190 data={data} />
        <FinalCta190 />
      </main>
    </div>
  );
}
